import {useState,useEffect, useCallback} from 'react';
import { useLocation } from "react-router";
import { i18n_langs } from '@/i18n/config';
const specifiedDate = Date.parse('2024-09-25 00:00:00');
function transformPaths(paths: any = []) {
  const languagePrefixes = i18n_langs;
  let transformedPaths: any = [];

  paths.forEach((path: any) => {
    languagePrefixes.forEach(prefix => {
      transformedPaths.push(`/${prefix}${path}`);
    });
  });

  return transformedPaths;
}
const paths = [
`/wallet`,
`/relay-transfer/solana`,
];

 const newRoutes = transformPaths(paths)

export function useNewRouteModule(){
  const location = useLocation();
  const [noNewMenu, setNoNewMenu] = useState<any>(JSON.parse(localStorage.getItem('noMenuNew') || "[]"));

  useEffect(() => {
    checkAndUpdateCache(specifiedDate)
  }, [])
  useEffect(()=>{
    setNoNewMenu(JSON.parse(localStorage.getItem('noMenuNew') || "[]"));
    updateNoMenuNew(location.pathname)
  },[location.pathname]);

  function checkAndUpdateCache(expirationTime: any) {
    let storedTime: any = localStorage.getItem('menuCacheTime')
    let storedTimeTmp: any = new Date(storedTime)
    let unix = Date.parse(storedTimeTmp)
  
    if (!storedTime || expirationTime > unix) {
      localStorage.removeItem('noMenuNew');
      setNoNewMenu([]);
      localStorage.setItem('menuCacheTime', new Date().toISOString());
      console.log('Menu cache cleared and updated.');
    } else {
      console.log('Menu cache is still valid.');
    }
  }

  const updateNoMenuNew = useCallback((key:string | string[]) =>{
    let el = Array.isArray(key)?[...key]:[key];
    const updatedMenu = [...new Set([...noNewMenu, ...el])];
    setNoNewMenu(updatedMenu);
    localStorage.setItem('noMenuNew', JSON.stringify(updatedMenu));
  },[noNewMenu])

  const getIsMenuNew =useCallback((key:string) => {
    // console.log('判断',key)
    // console.log('rendernwe',key, newRoutes.includes(key), !noNewMenu.includes(key))
    return newRoutes.includes(key) &&  !noNewMenu.includes(key);
  },[newRoutes,noNewMenu])

  return {
    noNewMenu,
    updateNoMenuNew,
    getIsMenuNew
  }
}